/** Production builds do not include or expose the mock-data reset boundary. */
export function resetDemoData(): boolean {
  return false;
}
